import Content from "Areas/Documents/content";
import ContentUpload from "Areas/Documents/contentUpload";
import { CONTENT_MODE_TAB } from "Areas/Sidebar/Documents/constants";
import React from "react";
export default function ContentSwitcher(props) {
    return props.contentModeTab === CONTENT_MODE_TAB.UPLOAD ? (React.createElement(ContentUpload, { rowActionsPanelHeight: props.rowActionsPanelHeight, bottomOffset: props.bottomOffset, onInProgressChanged: props.onInProgressChanged })) : (React.createElement(Content, { rowActionsPanelHeight: props.rowActionsPanelHeight, bottomOffset: props.bottomOffset, onInProgressChanged: props.onInProgressChanged }));
}
